import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import moment from 'moment';
import { Subject } from 'rxjs';
import { IUpdatedDateRange, MAT_UK_DATE_FORMATS } from '../../models/nt-company';
import { MatDatepicker } from '@angular/material/datepicker';
import { CompanyService } from '../../../../services/company.service';


@Component({
  selector: 'app-date-range-selector',
  templateUrl: './date-range-selector.component.html',
  styleUrls: ['./date-range-selector.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MAT_UK_DATE_FORMATS}]
})
export class DateRangeSelectorComponent implements OnInit , OnDestroy, AfterViewInit{
    years: any[] = [];
    startDate: Date;
    endDate: Date;
    
    selectedYear: any;

    @Output('selectedDateRange') updatedDateRange = new EventEmitter<IUpdatedDateRange>();

    @Input('region') region = '' ;
    @Input() basicMode = false
    
    sub = new Subject();

    @ViewChildren(MatDatepicker) datePickers: QueryList<any>;

    constructor(private comp: CompanyService) { }

    async ngOnInit(): Promise<void> {
        this.years = await this.comp.getFinancialYears();
        const startingDate = this.comp._selectedDateRange.value;
        if(startingDate){
            this.selectedYear = await this.comp.getFinancialYear(startingDate.yearId);
            this.startDate = startingDate.startDate;
            this.endDate = startingDate.endDate;
        }
    }

    ngOnDestroy(): void {
        this.sub.next(null);
        this.sub.complete();
    }
    
    ngAfterViewInit(): void {
        this.datePickers.forEach(p => {
            if(this.region.indexOf('US') > -1 || this.region.indexOf('CA') > -1){
                const d = p._datepickerInput._dateFormts;
                d.parse.dateInput= 'MM/DD/YYYY';
                d.display.dateInput ='MM/DD/YYYY';
                p._datepickerInput._dateFormts = d;
            }
        })
    }


    onYearChanged(){
        this.startDate = this.selectedYear.yearStart;
        this.endDate = this.selectedYear.yearEnd;
        
    }

    emitDates(){
        const newValues: IUpdatedDateRange = {
            startDate: moment(this.startDate).toDate(),
            endDate: moment(this.endDate).toDate(),
            yearId: this.selectedYear?.id
        };

        this.comp.updateSelectedDateRange(newValues);
        this.updatedDateRange.emit(newValues);
    }

}
